import React from 'react';
import{moneyFormatter} from '../library/FormatUtil';
import './ConfirmationConvenienceFee.css';

export default function ConfirmationConvenienceFee(props) {
  return (
    <>
      <tr>
        <td className='td--confirm-charges'>Convenience Fee</td>
        <td className='confirm-page-convenienceFee pr-2 text-end'>{moneyFormatter.format(props.confirmationData?.convenienceFeesTotalAmount)}</td>
        <td></td>
      </tr>
    </>
  )
}
